// extracted by mini-css-extract-plugin
export default {"addContainer":"add_addContainer__8YphE","text":"add_text__Hxsnw"};